/* Frost gifting — arrow + dot slider. Same one-scroll-position-per-card
   mechanics as frost-collection.js, plus a "no-overflow" toggle on the
   wrapper so the arrows fully disappear (not just fade/disable) once every
   card already fits on screen — dots use their own is-hidden toggle for
   the same "nothing to page through" state.
   Mobile shows pages of 4 cards (2 x 2) that swipe a full page at a time;
   dots appear only when there are more than 4 cards. */
(function () {
  function initFrostGiftSlider(section) {
    var wrap = section.querySelector('[data-frost-gift-wrap]');
    var track = section.querySelector('[data-frost-gift-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-frost-gift-slide]'));
    var prevBtn = section.querySelector('[data-frost-gift-prev]');
    var nextBtn = section.querySelector('[data-frost-gift-next]');
    var pagination = section.querySelector('[data-frost-gift-pagination]');

    if (!track || !slides.length) return;

    var visibleCount = 1;
    var totalPositions = 1;
    var currentIndex = 0;
    var dots = [];

    var PAGE_SIZE = 4; // mobile: 2 x 2 cards per page

    function isMobile() {
      return window.innerWidth <= 989;
    }

    function getVisibleCount() {
      return parseInt(getComputedStyle(section).getPropertyValue('--frost-gift-columns')) || 4;
    }

    function getGap() {
      var style = getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap || 0);
    }

    // Desktop scrolls one card at a time; mobile scrolls a whole 2 x 2 page.
    function getStep() {
      if (isMobile()) return track.clientWidth + getGap();
      return slides[0].getBoundingClientRect().width + getGap();
    }

    // Mobile grid: cards 1-4 fill page 1 row by row (1 2 / 3 4), 5-8 page 2,
    // and so on. Each card is placed explicitly because CSS grid's column
    // flow alone would fill top-to-bottom (1 3 / 2 4).
    function layoutPages() {
      var mobile = isMobile();
      var pages = Math.ceil(slides.length / PAGE_SIZE);
      track.style.setProperty('--frost-gift-mcols', pages * 2);
      slides.forEach(function (slide, i) {
        var pos = i % PAGE_SIZE;
        var page = Math.floor(i / PAGE_SIZE);
        slide.style.gridColumn = mobile ? String(page * 2 + (pos % 2) + 1) : '';
        slide.style.gridRow = mobile ? String(Math.floor(pos / 2) + 1) : '';
        slide.style.scrollSnapAlign = mobile ? (pos === 0 ? 'start' : 'none') : '';
      });
    }

    function buildDots() {
      if (!pagination) return;
      pagination.innerHTML = '';
      dots = [];
      if (totalPositions <= 1) {
        pagination.classList.add('is-hidden');
        return;
      }
      pagination.classList.remove('is-hidden');
      for (var i = 0; i < totalPositions; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'frost-gift__page-dot';
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            goToIndex(index);
          });
        })(i);
        pagination.appendChild(dot);
        dots.push(dot);
      }
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-disabled', currentIndex <= 0);
      nextBtn.classList.toggle('is-disabled', currentIndex >= totalPositions - 1);
    }

    function goToIndex(index) {
      index = Math.max(0, Math.min(index, totalPositions - 1));
      currentIndex = index;
      var step = getStep();
      track.scrollTo({ left: step * index, behavior: 'smooth' });
      updateDots();
      updateArrows();
    }

    function recalc() {
      layoutPages();
      if (isMobile()) {
        totalPositions = Math.max(1, Math.ceil(slides.length / PAGE_SIZE));
      } else {
        visibleCount = getVisibleCount();
        totalPositions = Math.max(1, slides.length - visibleCount + 1);
      }
      currentIndex = Math.min(currentIndex, totalPositions - 1);
      if (wrap) wrap.classList.toggle('frost-gift__slider-wrap--no-overflow', totalPositions <= 1);
      buildDots();
      updateArrows();
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var step = getStep();
        if (!step) return;
        var index = Math.round(track.scrollLeft / step);
        currentIndex = Math.max(0, Math.min(index, totalPositions - 1));
        updateDots();
        updateArrows();
      }, 100);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(currentIndex + 1);
      });
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(recalc, 150);
    });

    recalc();
  }

  document.querySelectorAll('[data-frost-gifting-section]').forEach(initFrostGiftSlider);
})();
